import { Grade } from "@mui/icons-material";

export const Bio = {
  name: "Sankeerthana Kodumuru",
  roles: [
    "Full Stack Developer",
    "Programmer",
  ],
  Email:"sankeerthana.kodumuru@stonybrook.edu",
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning, I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/sankeerthanak",
  resume:
    "https://drive.google.com/file/d/1IZpw3h55WNxhxl1eIxyEuKPO4x9cu2V0/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/sankeerthana-kodumuru-b701271b0/",
};

export const skills = [
  {
    "title": "Programming Languages",
    "skills": [
      {
        "name": "Python",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg"
      },
      {
        "name": "c/c++",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/cplusplus/cplusplus-original.svg"
      },
      {
        "name": "Java",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg"
      },
      {
        "name": "c#",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg"
      },
      {
        "name": "Go lang",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/go/go-original.svg"
      }
    ]
  },
  
  {
    title: "Web Technologies",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAY1BMVEWCgoL////l5eXk5OTm5ubu7u74+Pj19fXx8fH7+/vr6+t+fn52dnZ7e3t8fHzz8/OGhoaTk5Pa2tq3t7e7u7utra3Q0NCZmZnFxcWkpKSMjIzKysqpqanX19e/v7+dnZ1ra2tH/Sn9AAASPElEQVR4nOVdbZuyKhBWwTcErcxqa7fO//+VB9RKGF6tdvWc+bLPNY+m48DMzc0AURzHWYKTjP9FOEn5nzTBaKJNPLW5UYtxQozawqYtH1o8V4ui/4eFKEG9hcn4fgmaqU2S0ZaHNndpi0Fbjlr8Ni0atVGWZXmapjn/y/8U/E/B//6etnmnttFoI/4BemcgxUVBWuLS8iaES/6XENLwPw1vSpPPngzXPj67TYtDtIhrI6ztZm/pkuKZDbcpLgt0uV73+7b74tJ1bdterztUZDgl5Se6JJpoP+ZD/uNNnKNTdztHlFJWV7LUjCuj8609oIx/hfRzPvxI3yqanBzaIzeNGxbZpKq4pdG2PeBcdKKXepyhH747lgotut4iyuymKYYyGt1O6aRpvi+WvrXzYZKSXbehDscZrKxp1F1wms7sfNZ8iAa/oLGbIeSjJRrt9RjmO+hLtj31HkDD+6GhS6Kxm3losaKNAs0yG9uQ042+Yt1dano8lS+ahT6QLUjH2BvMG42sOxKTt2WLV8MLwqT42b7FfU+p6PYkUunrQSd6PUU0pK3e576nsKgl8euJQ84W4ck/IWj/UmyxScW+EQlO/gi9M1vkqPuYfYONXfGWbDHbh+1H7Rts3AdCNUX7Qj/M8lNUf9g+IXV0KssX+uH8WIo2n4gvOmFnFAjVprF0bj7Mvukv2SeEfudkbj6cBdUScnhz/nMJ745kHoCbh0uz2286cBB2K3NvqDbFpeHZAse/7cBBKnpKfZvmS1wbSY6/78BB2FGid/wAXPAYvznMGvy9R6rqEH+Ya0ua6185cBDaEm1eQO/i2vDxt3KgSdgRuUmA2Vwb2W3+roXepdqgIAAX0g/zw187cBB2yD/DtaXt33bBp/DO6IBqs0ZP6dcyPCiEfZXeAM4b0xTH3xhH+Aq72aHaFNP4RRqcnP8+xkylOqO3ZguMFhBEZRlCqgmqhXJtJdr8tUE6yd/GtZVkaQ4cJS0n75tqE0fqw7VhtFADo2j3Fq4NL7OJ9rJ5C9eWLNdAHlHdAM7ZD/OFpQlZqm2hQrU8kGtLj0s2kJt4dAE4Rz5Mv5aEZHRS6wCcP9eWt8vBoiahJzuAs0YacljKaMIm9IKtkcaWLXbL96AQtsMWAGcZHyZ4wXlCkk0410Z6Vm3hYfQp1TZWoJoX19Zc19FGhbCOhI+e8M8aosxd6CGYa8PJX790mFTBXFu8mk44SHUsIdeW27i2VWTCqdALCeHakmxtBnITrflQ5drIbV1ttJctCeDaVtdGhdCDPtLossUK26gQmjW+XNv3Ctsol+o7s3NtZEwcGVqnC7kTf0YriJ1ry9cCuKGc/bi203rwqCrs4sW1/fVrviKVB9fWtEtnZmxSt42La0vQetuoELZzcW2kW2emuEvVObm2dbtQpH0719bs1+1CkfaJbWyBydpdyIONNVuQdu0u5E5sCeTaSErEGJ+kxfoN5CYWI9c2ADh59PQT3EjF4roqOh+3x/OG/5u5y/oAJvT9qup1GwO6ZD+xmWvbej5sfCSj5/ZARAMfJCM/+1tlLz5lRawI8QP61Zd649Fw5TZOTFyb57PGV2VfP6X6UCGojay/A27wI2Yr9TbjrBFFyXQEnOcj15ZnTUC2p+eDzrpRdluzjdAX8dbjuTRRbjLzuVVX5gPXlitcm3+qoEdksa935Nn4Y/SiXty42w5rlXtyy8uy2JAPfYdNbLNz2CfkZHxtmqrXXpxPPqu32PzODgau7eZnIL162Ce+4tk0StmAa13tlKrxyTp1W91kru1BknrFmaqv8PCTzvCL9bd6pYP7omqn3zmuR4lubHH1iTMUxgmLXAwvAt7YEjciTXDKHK262uPHngVPH6am9CK92j7EQPO3Zo16pY2DBoni7HrPSYUGH+OTYYzvkwxhGJxrIogcpZlaoGrgdtdPUJJDrs1j0h42LrcYmh+I/uauBS51dML+nl0Os4U73fd1HUDK5HDat/vrAWW6/zZlDQoyjomHVt1ty4R3qbocjp6cLCnr4Ovj9nzf1YND8HOrAg8hX/o3ZwDy6R8LEoUPAoo2mcy1cZDjJLqrLXj3n7OCsistmNN/O/h72lcAXd+viIlibpTEtRVO+oKpjRCddW+kATzY0BUBcuhgtBHJWxKPTtj/uPgwUj5sDG3pIaDfGFdfwJRpYA5AjNRkgUppy65M+LhPgAqJa8t97phIaUbWfKiqAk/TtaqFIGOBj+DVCe+/PeXasCsbKnGhtI/M1RczLCcCTTDeyxeCRLH3H/7s5P3asGNJk9pnXNQDxfL1hkANEYTcTtVE4dkJhdQnOVs4SbbQtkJlWGYigKgK49OpDWqi8O2EQqqWTLk20thBKZNzgE/AVj6/6TIwkJoMUoGH/Tshl2Mjc232q2Xo6zXMUrrQyQA71Qg2YcNALw0s55W5Nvv4rJZ7oRPZ9yI3sdKYW1SIkN+vVEFPQCfsfziXuDY7oqH59EmepSiKC4zVDwCVjYNKNR6XgVwuv//OteV52pgake5d/VyoRhHz0AUMpPqSOpAoQgvt6lPT2zbEUvusIZPgjHdjUbqY0UKA6HtvqXYH19RX3VAbPeRDYiWhqPQoF7ybvLrnffRHsYb3AzWNzKiAuZGnhYjYWp7Ckvh/Sya9uYUxrKV+Lr6GmihCO6GQ82jhEEttV9bSwDcgolVS80vNN4KBVKkmiqBMeJfp2MIYy4XIDSZkklhOo5YLmYPg8oej0x8tJ1xbYbNQ7k4hdZkydLPdCQdSU5lXhkaLwYeEkKK0/sRRelpISZgchK3eB4ThRLJ5FT4MpYSk5RBLbfMGlZyYgibgpHhhnX6t5O8oycyS8/7pYyzFV8tXklF3wzb+EkndyxJqxGO0RJ6Ques+6v3UQttEjmsizVcsnK8QMJAaZXYtaHWNH1xbaesicC5srji6MJyR6r/L7OKJ6ppz2/IhllotfJeBrioBzeRwPLsTit/bk2c+tI3w32ehk87TcK0vLL7iFj65Nhvwrt9mobMcSdMVZ9snIBV5cG3E9nX13WOOOOGQpp3aA7D718ZY+ksWWgeh/TvpbpptYj+svVtoA1RggDpbXPUIeug2O9TcLRR8VGHz4fv6ocNCOKXYiyONWiz8ikWx3sDT2CIN0z53loX2dzU1lrkp/x5p+mxhs1DOFqL8dqZgeywFjNRDunkZo+rSJ9dmzYfSAJz8Q2eL3UDLDLov96VYyDP+nWtrbBYyaQrihehtfx0wSfPyQ6s2e3Bt1vYjD/I+ZqHFQHNdjv0nReTyGVvINI2V75gvgP5VTJyz4vM+thgstI2AZTrzIxaqiaJQYcacEUY9+rCPpdZamvkshreoiWILaq9mpAy2688eGCy03i8nRJ/asFBRh6AnBkF4+D4yFBFPrk1OVB9YNaTSv31BLcj/wSmDNhOuzTq55k1dzxSQKHpbAIXqUUgsC82eXBvC1jeQwkBQtbuXqIliDHugnQanjOnMTGptAnKDmWuISdRCnUfGBe00MGWcpZkZ+9yTVA0V0hHZVAyXqCOKs/F/Aj/ubfRhURRNXlpBsdwRDTVc2hsvu4noiSjVU5MpCrVkJSxlVG3JbbtzbaaSnvFamVzwX1gj5xntJWqikLu56sSQGRp2kOra7F9HflP/SWDpy2hDFFMLSqSAUIN6z4BlS2Ief1LXZq/FkJup92PkGKJjaUCiUJwEeI2AlMGjx7OuLcHEfrUM3HzHFzK41IEhlSGBfVx1YsCeJESU85bJ3UI7GFN6ix//JY9pdRVboKITJK0KtFPvMoIjCalrUx/ks5uiMl+mwUKgm2mwJ+TfPA2c1rWVOQc3jtpEqtQS+MyrO9wDE4U+D6kW+i3t4TFMrCEts0ddmyPLgfIz5wkClVw0rQnAYFJLOzCD8dQvZYgZdmkNqatGGGRf05qm0b6NUhUO469viTpsp36xPFbWkDYu0AdQ4o/lMCtQ6g1dCBKFOSWrT8492ulQ5/3g2ji4yVyTCrCyPm4N/CCLADMIG6Baom4mD2A79UgZ9bXhiE3Y9lhR4kxymqmvvGPAkRWN4Iw83C8Flv5b1j2B9Q3ulEF3GKwKchMwunXNh+/oeRJuzejmW7O+FDZA4BcrbAT+dqeMTQbXkDpHRZpFM4Mnd5e9OMq42192aoFaLw0MIaBX258M5hVdA5yqfZwNxWMp7tcfYjc9UQetrnwKbB2gxTs+L2ynjtlvdhlOXcaTNaQYu9MMm2Ui3BAcLIJzDvzgMjA75mDJzDWkzDa7oJccLs2AcxTOB8Nb7CsTpmtIB66tLEjqnITmUp/1iwyNomsZteoQD2IEVNlaU0Z9SnNu1IRrG3Yc8Bsx+KzFf4huFAJ+wWtIDdvptyW/GHYc8FuPT8EKCaPkuhPaYAL3eqxm+s2Y3/r1+LodeDz3VKgA9WCQkxbzgEThSd7BdmpMGYKTePqw59rynGOcwrsmgG08ljxfIu0HA4nCm/aB7dSUMmg+GDXl2ob92vypUFZdtcn9LunecAgySBT+82bem6KIzbAM+7WFMPbifHBDvSQ+Gc+whoWyATuJwnaqJ9Aowsb92sL2GKppddwfyMSZOTmITYYsrV19x6DFTGApcqzdXm4bg/3a7uePkfBtL8UidVZtztvteRP1/7b65HzcyhL2tI1y91aHUtipX7rN/RhPuLZxvzYHqbgS+d/t11aWgmsjOf/L/6Tr33OPCahWlg23JisnXNu42/VaN0l+ipjPtZ6N8B/Z+9JyNgJZuRN7jk3esXzk2sY/Ta6hHNYkrCgGa5pC5dri+9kItvUzi5f66nM2wpqbaeV1NsLa9/NWz0Z4cG09yBFbZJTzClaXIBsyQjWMn7EUno1gX424ZKE/WDkbQbPbNcK8wfov116UiLMR7hYihWsry4L/fQA4n920Figsf0C1Jwwt5WwxJn+yosOsnsLGrQS9ziFNV3nOTBpyDumHyrk/KfTR+RQfTri2CYDLV5cU2amUrNBzbRN3ktWd2dXEmlPJrOeQ/vU7B0oSfA4pXtWZT/ez80znkHJbe65NAnAzquP/TEQZhQTVjFybfJjHarpiP/8uQTWQLTDSWJgs+bxqSTYAqk0tlLk2CcClazlLFqUqVDNzbUryX0W0EdMZKlTzOYc0WdWZzrZTq60+TMnX0k1kw7ncifkcUhnkKACuycuFY/DqFuugmpVrUwEcLIdZkFRnPVTzPZd7mHNbcs7YTDpfEnIOqQzg/toMi5igmoVrGwGcpHXVD/+dZCXWQjVs59pgg13qIUm5Eaq5uDbVwnKJDbXiBhqhmotrgwAOb5bmxuqMSzNUc3FtcvIf4s/CkoZIExaoFpYtBm0xa3PGT0l9hHnBmi2sPrwDuNtyABy7OaCamWtrLAAu3i9lpEH3LqjmwbWNWtmd12WYKBbFOaCaF9em0ZKfJfTFeufufD5cm1aLkfGUqt8Sdu7fzAHVDFybB4CLy++/bam0Hd5MhmpYhWoTrSVbID0D9/5tIwKk3yzHA6r5cW0GLbEci/dhYVuEVVCmh2qeXJsEiCba8o/SBt0X/Ttk2jcL5dqQTUt2f+BGdu6PzEy8oJo316YHcFxL9HX4n5OKtinW5AWPbGHn2sza/PabTZXeUqIHZU5tZIRqDm2TGZYbfEBYdMkAiNRDS6jVcW2q4wzaIr5algK/Typ2JcQIyt7BtVm0PP9/2saKdplf53uBazNoxe/ku9tHbazokUwDqATK9FoL1yaSKYRqd21u0hZfH7OR+6+IG/AOE1DmAeAgE2UBcIlWS1BHPxFzatohXQbwgWqhXJtdy7Njetm82ZEV3Vwx8QBl7+LaTADufm0c777e6EhGv3ZxagNlZqimal+MNA9tgsv4YFzQFSQ8uhxSgsNjiiHSvJQtplrx62i/pS/lyKqm22s2Ly+8zLX5aHmXJGKXhXqOlVXFou6EyDCE9wVl7+HaQrR5nmXodItYkJUVo9HtuhNbbweCMqfWiLyDAJxGuzt9b/stM5ztkhu37U48WDV4Bih7L9cW0iV5b2jiHJ262zmilD12B6meu4RQGp2P3QWJ0Jc+u87zF5LZnW821+YVViVtI5Ja2aDLdb/ft93X7fbVdW3b7q871GT8P6VRrQcoCw6req5tJoC7ayGk6ktXSJ/BY5KSHgoRy7VWUBYG4KxMVBCAy21aArVyI9RrZ0O1l7g2K4BLVG0+aIlR+yoo+wjX9prWC369rn0AuE9HmlTu+3rtRyPNv+c/cIe0nzmlAAAAAElFTkSuQmCC",
      },
      {
        
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    ],
  },
  {
    title: "Tools and Framework",
    skills: [  
      {
        "name": "Azure",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg"
      },
      {
        "name": "Jenkins",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/jenkins/jenkins-original.svg"
      },
      {
        "name": "Kubernetes",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/kubernetes/kubernetes-plain.svg"
      },
      {
        "name": "GraphQL",
        "image": "https://graphql.org/img/logo.svg",
      },
      {
        "name": "AWS",
        "image": "https://github.com/sankeerthanak/devicon/blob/master/aws.png?raw=true"
      },      
      {
        "name": "Asp.Net MVC",
        "image": "https://github.com/sankeerthanak/devicon/blob/master/asp.netMvc.jpeg?raw=true"
      },
      {
        "name": "Spring Boot",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/spring/spring-original.svg"
      },
      {
        "name": "D3.js",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/d3js/d3js-original.svg"
      },
      {
        "name": "Echarts",
        "image": "https://echarts.apache.org/zh/images/favicon.png"
      },
      {
        "name": "Git",
        "image": "https://raw.githubusercontent.com/devicons/devicon/master/icons/git/git-original.svg"
      },
    ],
  },
  {
    title: "Databases",
    skills: [
      {
        name: "SQL",
        image: "https://cdn.iconscout.com/icon/free/png-256/sql-4-190807.png",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Netlify",
        image: "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        "name": "Postman",
        "image": "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg"
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    //img: "https://1000logos.net/wp-content/uploads/2023/01/Accenture-Logo.png",
    role: "Fullstack Engineering",
    company: "Accenture",
    date: "Aug 2021 - July 2023",
    desc: "Worked on document information extraction software to analyze invoices using REST APIs and front-end features with C#, ASP.NET, React, and MS SQL, applying agile methodologies and implementing continuous integration and deployment for the project.",
    skills: [
      "C#",
      "Asp.Net",
      "React",
      "Azure Form Recognizer",
      "Redux",
      "Kubernetes",
      "Jenkins",
      "Docker",
      "SQL",
    ],
    // doc: "https://media.licdn.com/dms/image/D4D2DAQFlp60ZqHuaFQ/profile-treasury-image-shrink_1280_1280/0/1691180828512?e=1692381600&v=beta&t=mM5Y_NE5EPlQhez5FAN6NLVSKcO_Ojt_9Gq3mnFGkAQ",
  },
  {
    id: 1,
    //img: "https://beingzero.in/images/logo.png",
    role: "Software Engineer Intern",
    company: "Being Zero Private Limited",
    date: "May 2018 - July 2018",
    desc: "Developed APIs with Spring Boot and SQL, and a user-friendly website with TypeScript and AWS Elastic Beanstalk for application deployment for a printing service system.",
    skills: [
      "Spring Boot",
      "TypeScript",
      "SQL",
      "AWS"
    ],
    //doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
];

export const education = [
  {
    id: 0,
    img: "https://github.com/sankeerthanak/devicon/blob/master/sbu.jpeg?raw=true",
    school: "Stony Brook University",
    date: "Aug 2023 - May 2025",
    grade: 3.67,
    //desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Kalinga Institute of Industrial Technology, Bhubaneswar. I have completed 4 semesters and have a CGPA of 8.71. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at KIIT, where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Master of Science in Computer Science",
    "Relevant Courses": "Operating Systems, Data Science Fundamentals, System Security, Theory of Database",
  },
  {
    id: 1,
    img: "https://github.com/sankeerthanak/devicon/blob/master/vnr.png?raw=true",
    school: "Vnr Vignana Jyothi Institute of Engineering and Technology",
    date: "Jul 2017 - Jul 2021",
    grade: 4.0,
    //desc: "I completed my class 12 high school education at Methodist School, Dankuni, where I studied Science with Computer Science.",
    degree: "Bachelor of Technology in Information Technology",
    "Relevant Courses": "Data Structures, Algorithms, Database Management, Object-Oriented Programming, Computer Networks.",
  },
];

export const projects = [
  {
    id: 0,
    title: "AI4EHR",
    //date: "Apr 2023 - May 2023",
    description:
      "Worked on a dashboard which diaplays the insights from the health database for opiod overdose",
    descriptionMore:"In the AI4EHR project, harnessed the power of PostgreSQL to conduct advanced querying operations on a massive dataset spanning 16TB. This utilization of PostgreSQL significantly enhanced our ability to analyze data, empowering us to derive meaningful insights crucial for decision-making processes. Moreover, we transformed raw data into dynamic and interactive EChart dashboards, enabling real-time monitoring and providing actionable insights. This integration of PostgreSQL querying and EChart visualization not only facilitated comprehensive data analysis but also facilitated informed decision-making in a timely manner.",
    image:
      "https://github.com/sankeerthanak/devicon/blob/master/ML%20Dashboard.png?raw=true",
    tags: ["PostgreSql", "Echarts"],
    category: "web app",
    //github: "https://github.com/rishavchanda/Podstream",
    //webapp: "https://podstream.netlify.app/",
  },
  {
    id: 1,
    title: "Payroll Management System",
    //date: "Oct 2022 - Present",
    description:
      "Developed a system that automates the process of managing employee salaries, deductions, and benefits, ensuring accurate and timely payroll processing. It centralizes database management, enhances data security, and improves overall efficiency in HR operations.",
      descriptionMore:"Engineered a comprehensive solution to optimize HR operations by developing a sophisticated system, meticulously crafted with over 1500 lines of code. Through adept utilization of encapsulation and the singleton design pattern, we centralized database connections, ensuring both data security and system robustness. Moreover, we revolutionized payroll processing by implementing hash tables, enabling swift employee look-up and resulting in a notable 20% reduction in processing time. This combined approach not only streamlined HR processes but also significantly enhanced efficiency, demonstrating our commitment to innovation and excellence in system design and optimization.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/payroll.png?raw=true",
    tags: [
      "C++",
      "File Handling",
      "Oops",
    ],
    category: "backend app",
    // github: "https://github.com/rishavchanda/Project-Management-App",
    // webapp: "https://vexa-app.netlify.app/",
  },
  {
    id: 2,
    title: "Smart Travel Planner",
    //date: "Jan 2023 - Mar 2023",
    description:
      "The Smart Travel Planner app simplifies trip planning with intuitive interfaces, utilizing Google Maps and Calendar integration for efficient itinerary management. It centralizes user profiles and travel plans for easy access and organization.",
      descriptionMore:"Orchestrated a sophisticated application architecture by intertwining React for a dynamic front end and Flask as the back-end framework in a Python environment. Leveraging MongoDB for efficient storage of user profiles and travel itineraries, and harnessing the power of GCP for seamless deployment, we ensured optimal performance and scalability. Additionally, we seamlessly integrated Google Maps API for route planning and navigation, and Google Calendar API for itinerary scheduling within the application. This integrated approach led to a remarkable 35% improvement in planning efficiency, showcasing our adeptness in utilizing cutting-edge technologies to deliver impactful solutions.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/smartTravel.jpeg?raw=true",
    tags: ["React", "Flask", "Python", "MongoDB", "Google APIs", "GCP"],
    category: "full stack",
    // github: "https://github.com/rishavchanda/Brain-Tumor-Detection",
    // webapp: "https://brain-tumor.netlify.app/",
  },
  {
    id: 3,
    title: "Health Monitoring Dashboard",
    // date: "Dec 2021 - Apr 2022",
    description:
      "The Health Monitoring Dashboard offers a user-friendly interface for tracking and analyzing health data. It integrates D3.js for visualizing insights, aiding in informed decision-making.",
      descriptionMore:"Developed a robust application ecosystem by employing React for a dynamic front-end user interface, complemented by Node.js with Express and MongoDB for the back-end. This combination facilitated efficient data storage, processing, and ensured the security of API endpoints. Additionally, we seamlessly integrated D3.js to deliver comprehensive insights, empowering users with actionable data for improved decision-making processes. This cohesive integration of technologies underscores our commitment to delivering powerful, user-centric solutions tailored to meet diverse business needs.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/health.png?raw=true",
    tags: ["MERN Stack", "D3.js"],
    category: "full stack",
    // github: "https://github.com/rishavchanda/Buckoid-Android-App",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 4,
    title: "AirBnb Replica",
    // date: "Dec 2021 - Apr 2022",
    description:
      "This project is a comprehensive replica of Airbnb, built with microservices architecture using Golang. Key functionalities include user management (Login and Profile creation), Property Searching, and Booking services.",
      descriptionMore:"Airbnb replica project utilizes Golang for microservices development encompassing login, profile creation, property publishing and booking functionalities. MongoDB ensures fast and schema-flexible data storage for user records. JWTs replace traditional sessions for enhanced security and scalability, with Redis handling JWT secrets for efficient in-memory caching. Deployed on AWS using Docker, the project achieves high scalability, managed through GKE for container orchestration. AWS SES manages booking notifications, while S3 stores and retrieves property images. AWS API Gateway integrates load balancing and Kubernetes IP management, ensuring robust API endpoint configuration and management.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/hotel.jpeg?raw=true",
    tags: ["Go lang", "MongoDB", "Redis", "Kubernetes", "AWS", "Javascript"],
    category: "full stack",
    // github: "https://github.com/rishavchanda/Buckoid-Android-App",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 7,
    title: "Youtube Data Analysis",
    // date: "Dec 2021 - Apr 2022",
    description:
      "This project aims to analyze YouTube video data using AWS services to build a scalable ETL system and insightful dashboards from a Kaggle dataset of daily trending videos.",
      descriptionMore:"This project aims to ingest, transform, and analyze YouTube video data using AWS services like S3, IAM, QuickSight, Glue, Lambda, and Athena. It focuses on building a scalable ETL system to manage diverse data sources and create insightful dashboards, leveraging a Kaggle dataset of daily trending YouTube videos across multiple regions.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/yde.jpeg?raw=true",
    tags: [
      "AWS S3",
      "AWS IAM",
      "Amazon QuickSight",
      "AWS Glue",
      "AWS Lambda",
      "AWS Athena"
    ],
    category: "machine learning",
    // github: "https://github.com/rishavchanda/Buckoid-Android-App",
    // webapp: "https://play.google.com/store/apps/details?id=com.rishav.buckoid",
  },
  {
    id: 10,
    title: "Decentralized Social Media Platform",
    // date: "Jun 2023 - Jul 2023",
    description:
      "The Decentralized Social Media Platform prioritizes content security and user privacy. It integrates IPFS for decentralized content storage and uses DIDs for user authentication, ensuring a secure environment for 500 users.",
      descriptionMore:"We spearheaded the development of a robust social media platform, elevating content management security while accommodating 500 secure user logins. Through strategic integration, we implemented a decentralized database using IPFS to bolster content management security, ensuring data integrity and resilience against centralized vulnerabilities. Moreover, we leveraged DIDs for user authentication, fortifying user identity verification mechanisms and enhancing overall platform trustworthiness. This seamless integration of cutting-edge technologies underscores our commitment to delivering secure, scalable, and innovative solutions tailored to meet the evolving needs of modern digital platforms.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/social.jpeg?raw=true",
    tags: ["React.js", "Node.js", "Express.js", "IPFS"],
    category: "full stack",
    // github: "https://github.com/rishavchanda/Job-finder-App",
    // webapp: "https://github.com/rishavchanda/Job-finder-App",
  },
  {
    id: 5,
    title: "Flight Delay Prediction",
    // date: "Jun 2021",
    description:
      " Constructed predictive models leveraging data analysis techniques to accurately forecast flight delays, integrating diverse data sources such as historical flight data and weather forecasts by web scraping to optimize operational efficiency.",
      descriptionMore:"Engineered predictive models with precision by leveraging advanced data analysis techniques to forecast flight delays accurately. Our approach involved integrating diverse data sources, including historical flight data and real-time weather forecasts obtained through web scraping. By amalgamating these disparate datasets, we optimized operational efficiency, enabling airlines to anticipate and mitigate potential delays proactively. This seamless integration of data analysis and predictive modeling underscores our commitment to enhancing operational effectiveness and improving passenger experience in the aviation industry.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/flight.jpeg?raw=true",
    tags: ["Python", "Machine Learning"],
    category: "machine learning",
    // github: "https://github.com/rishavchanda/Todo-Web-App",
    // webapp: "https://rishav-react-todo.netlify.app/",
  },
  {
    id: 6,
    title: "Detecting The Cyber Bullying Tweets",
    // date: "Jun 2021",
    description:
      "The Cyber Bullying Tweets Detection project effectively analyzes social media content in real-time. It employs advanced algorithms and data processing techniques to categorize comments accurately, contributing to research published in a reputable journal.",
      descriptionMore:"Harnessed the power of Apache Spark for real-time data processing, enabling the analysis of vast datasets with agility. Leveraging Spark's Matplotlib integration alongside the Naive Bayes Algorithm, we achieved enhanced performance in data classification tasks while maintaining an impressive 85% accuracy in categorizing comments. Additionally, our endeavors culminated in the publication of a research paper in the esteemed International Journal of Emerging Technology in Computer Science and Electronics, showcasing our dedication to advancing knowledge and innovation in the field of data science and technology.",

      image:
      "https://github.com/sankeerthanak/devicon/blob/master/cyber.jpeg?raw=true",
    tags: ["Python", "Apache Spark"],
    category: "machine learning",
    // github: "https://github.com/rishavchanda/Breaking-Bad",
    // webapp: "https://breaking-bad-webapp.netlify.app",
  },
];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
